import { render } from "./DataSetDialog.vue?vue&type=template&id=22ef0183"
import script from "./DataSetDialog.vue?vue&type=script&lang=js"
export * from "./DataSetDialog.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__